module.exports = __webpack_public_path__ + "static/media/carta_52.4547336e.jpg";